import { matchPath, useLocation } from 'react-router-dom';

export const useIsRoute = (route: string) => {
  const { pathname } = useLocation();
  return matchPath(route, pathname);
};
